import GoToTop from "@client/controls/GoToTop/component";
import TextComponent from "@client/viewer/layout/Entity/TextComponent/component";
import Place from "@client/viewer/layout/Place/container";
import {
  ContainerBody,
  ContainerContent,
  ContainerHTML,
  ContainerPopup,
  ContainerSidePanel,
  DotsMenu,
  Footer,
  Header,
  SidePanel,
  SidePanelToggle
} from "@client/widgets";
import Viewport from "@client/widgets/Viewport/container";
import type { WithChildren } from "@common/declarations";
import * as React from "react";
import FloatingMenu from "../widgets/FloatingMenu/container";
import Container from "./Container";

export default (props: Partial<WithChildren>) => (
  <Container>
    <Viewport className="page">
      <ContainerHTML>
        <ContainerPopup>
          <ContainerSidePanel>
            <SidePanel />
            <FloatingMenu TextComponent={TextComponent} />
            <ContainerBody>
              <SidePanelToggle isOutsideHeader />

              <ContainerContent>
                <DotsMenu />

                <Header />

                <Place id="main" source="content" />

                <Footer />
              </ContainerContent>
            </ContainerBody>
          </ContainerSidePanel>
        </ContainerPopup>
        <GoToTop />

        {props.children}
      </ContainerHTML>
    </Viewport>
  </Container>
);
